var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
var scheduleReportListState = {
    data: null,
    error: null,
    loading: false
};
var scheduleReportReducer = function (state, action) {
    if (state === void 0) { state = scheduleReportListState; }
    switch (action.type) {
        case Types.GET_SCHEDULE_REPORT_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_SCHEDULE_REPORT_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_SCHEDULE_REPORT_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_SCHEDULE_REPORT_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var ScheduleReportReducer = {
    scheduleReportData: scheduleReportReducer
};
export var scheduleReportData = function (state) { return (state.scheduleReportData.data ? state.scheduleReportData.data : null); };
export var scheduleReportError = function (state) { return state.scheduleReportData.error; };
export var isLoadsSheduleReport = function (state) { return state.scheduleReportData.loading; };
export default ScheduleReportReducer;
